<script>
import getEnvVariable from '@/utils/getEnvVariable';
import WSClient from '@/api/wst';

const url = getEnvVariable('VUE_APP_WST_API_URL');
const wsclient = new WSClient(url);

export default {
    name: 'WsConnector',

    mounted() {
        wsclient.connect();
    },

    unmounted() {
        wsclient.disconnect();
    },

    render() {
        return null;
    },
};
</script>
